import React from "react"
import PropTypes from "prop-types"

class LoaderSection extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="blue_loader" style={{height: this.props.height ? this.props.height : 200, width: this.props.width ? this.props.width : 200, margin: 'auto'}}>
      </div>
    )
  }
}

export default LoaderSection;
